import React from 'react'
import { Download, RefreshCw } from 'lucide-react';
import recurringdl from '../assets/recurringdl.png';
import onetimedl from '../assets/onetimedl.png'

const TwoWaysOfBusiness = () => {
    return (
        <div>
            <section className="py-16 bg-white">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="text-center mb-12">
                        <p className="text-2xl font-semibold text-[#4E6978] mb-4">
                            There are two ways to get your<span className='text-[#F09900]'> perfect list </span>of new businesses:
                        </p>
                    </div>

                    <div className="flex flex-col lg:flex-row items-center lg:justify-center gap-6 lg:gap-12">
                        <div className="bg-[#F5F5F5] max-w-xs rounded shadow-lg p-8 text-center border-3 border-[#4E6978]">
                            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                {/* <Download className="w-8 h-8 text-blue-600" /> */}
                                <img src={onetimedl}/>
                            </div>
                            <p className="text-xl font-semibold text-[#4E6978] mb-4">One Time Download</p>
                            <p className="text-[#4E6978] mb-6 leading-6">
                                Looking for a quick boost to your marketing pipeline? Get the latest list of new businesses in your area.
                            </p>
                            <div className='mt-6'>
                            <button className="bg-[#F09900] w-full hover:bg-orange-600 text-white font-medium py-3 px-6 transition-colors duration-200 cursor-pointer" style={{ color: 'white' }}>
                                Get Your List
                            </button>
                            </div>
                        </div>

                        <div className="bg-[#F5F5F5] max-w-xs rounded shadow-lg p-8 text-center border-3 border-[#4E6978]">
                            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                {/* <RefreshCw className="w-8 h-8 text-green-600" /> */}
                                <img src={recurringdl}/>
                            </div>
                            <p className="text-xl font-semibold text-[#4E6978] mb-4">Recurring Subscription</p>
                            <p className="text-[#4E6978] mb-6 leading-6">
                                Get the latest list of new businesses in the U.S. or by state every week, month or year.
                            </p>
                             <div className='mt-6'>
                            <button className="bg-[#F09900] w-full hover:bg-orange-600 text-white font-medium py-3 px-6 transition-colors duration-200 cursor-pointer" style={{ color: 'white' }}>
                                Start Your Subscription
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default TwoWaysOfBusiness